var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkflows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.887,
    height: 24.68,
    viewBox: "0 0 24.887 24.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "flow",
    d: "M24.47,19.982V15.456a1.769,1.769,0,0,0-1.778-1.761H15.582V9.168a3.551,3.551,0,1,0-1.778,0v4.527H6.694a1.769,1.769,0,0,0-1.778,1.761v4.526a3.527,3.527,0,1,0,4.416,3.854,3.524,3.524,0,0,0-2.638-3.854V15.456h16v4.526a3.551,3.551,0,1,0,1.778,0Zm-16.887,3.4A1.778,1.778,0,1,1,5.805,21.62,1.769,1.769,0,0,1,7.583,23.381ZM12.916,5.769A1.778,1.778,0,1,1,14.693,7.53a1.769,1.769,0,0,1-1.778-1.761ZM23.581,25.142a1.761,1.761,0,1,1,1.778-1.761A1.769,1.769,0,0,1,23.581,25.142Z",
    transform: "translate(-2.25 -2.235)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflows);
export default __webpack_public_path__ + "static/media/workflows.fba3f2a8195b819f6886cc4c6e647e38.svg";
export { ForwardRef as ReactComponent };